import React, { useState, useEffect } from 'react';
import axios from 'axios';
// import { location } from 'react-router-domrouter';
import { useLocation, useNavigate } from 'react-router-dom';
import './updateScrapRate.css';

const UpdateScrapRate = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { isEditing, scrapRate } = location.state || {};

    const [scrapName, setScrapName] = useState('');
    const [pricePerKg, setPricePerKg] = useState('');
    const [icon, setIcon] = useState(null);

    useEffect(() => {
        if (isEditing && scrapRate) {
            setScrapName(scrapRate.scrapName);
            setPricePerKg(scrapRate.pricePerKg);
        }
    }, [isEditing, scrapRate]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append('scrapName', scrapName);
        formData.append('pricePerKg', pricePerKg);
        if (icon) {
            formData.append('icon', icon);
        }

        try {
            const token = JSON.parse(sessionStorage.getItem('accessToken'));
            if (isEditing) {
                const response = await axios.put(`${process.env.REACT_APP_API_URL}/admin/rate/scraprate/${scrapRate._id}`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        Authorization: `Bearer ${token}`,
                    },
                });
                alert(response.data.msg);
            } else {
                const response = await axios.post(`${process.env.REACT_APP_API_URL}/admin/rate/scraprate`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        Authorization: `Bearer ${token}`,
                    },
                });
                alert(response.data.msg);
            }
        } catch (error) {
            console.error(error);
            alert('Error processingg scrap rate');
        }
    };

    const handleDelete = async () => {
        try {
            const token = JSON.parse(sessionStorage.getItem('accessToken'));
            const response = await axios.delete(`${process.env.REACT_APP_API_URL}/admin/rate/scraprate/${scrapRate._id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            alert(response.data.msg);
            navigate('/admin/getScrapRate');
        } catch (error) {
            console.error(error);
            alert('Error deleting scrap rate');
        }
    };

    return (
        <div className="form-container">
            <h2 className="form-title">{isEditing ? 'Update Scrap Rate' : 'Add New Scrap Rate'}</h2>
            <form onSubmit={handleSubmit} className="scrap-rate-form">
                <div className="form-group">
                    <label htmlFor="scrapName">Scrap Name</label>
                    <input
                        type="text"
                        id="scrapName"
                        className="form-input"
                        value={scrapName}
                        onChange={(e) => setScrapName(e.target.value)}
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="pricePerKg">Rate</label>
                    <input
                        type="text"
                        id="pricePerKg"
                        className="form-input"
                        value={pricePerKg}
                        onChange={(e) => setPricePerKg(e.target.value)}
                        required
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="icon">Icon</label>
                    <input
                        type="file"
                        id="icon"
                        className="form-input-file"
                        accept="image/*"
                        onChange={(e) => setIcon(e.target.files[0])}
                    />
                </div>
                <button type="submit" className="submit-btn">
                    {isEditing ? 'Update Scrap Rate' : 'Add Scrap Rate'}
                </button>

            </form>
            {isEditing && (
                <button type="submit" onClick={handleDelete} className="delete-btn">
                    Delete Scrap Rate
                </button>
            )}
        </div>
    );
};

export default UpdateScrapRate;
